import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=7bc381c2&scoped=true&"
import script from "./FavoritesPage.vue?vue&type=script&lang=js&"
export * from "./FavoritesPage.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesPage.vue?vue&type=style&index=0&id=7bc381c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc381c2",
  null
  
)

export default component.exports